// TODO This list closely follows our "feature" list. Can we unify them?
// Probably want to centralize creative generators that combine feature,
// asset, text, cta, analytics, etc. all in one.
import { Locale } from '../replicant/ruleset/locale';
import StateObserver from '../StateObserver';
import { CreativeText } from '../replicant/creatives/text';
import { getRandomItemFromArray } from 'src/replicant/utils/random';

export type CreativeType =
  | 'invite'
  | 'energy_gift'
  | 'gift'
  | 'visited'
  | 'lastWords'
  | 'revived'
  | 'card_request'
  | 'card_share_request'
  | 'card_share_donate'
  | 'card_share_trade'
  | 'janken_challenge';

type MessagesConfig = Record<
  'en' | 'ja',
  Record<
    CreativeType,
    Record<
      string,
      {
        text: string;
        cta: string;
      }
    >
  >
>;

const getConfig = (): MessagesConfig => ({
  en: {
    invite: {
      'en-invite_share': {
        text: 'A New Kind of Pet Raising Game!\nNo download required, you can play right now!\nLet’s raise a cute pet with me together!',
        cta: 'Play now!',
      },
    },
    energy_gift: {
      'en-energy_gift': {
        text: 'I sent energy gift to you!!',
        cta: 'Play now!',
      },
    },
    gift: {
      'en-gift': {
        text: 'I sent a gift to you!!',
        cta: 'Play now!',
      },
    },
    visited: {
      'en-visited': {
        text: 'This is a leaving note',
        cta: 'Play now!',
      },
    },
    revived: {
      'en-revived': {
        text: 'This is a leaving note',
        cta: 'Play now!',
      },
    },
    lastWords: {
      'en-lastWords': {
        text: 'This is a leaving note',
        cta: 'Play now!',
      },
    },
    card_request: {
      'en-card_request': {
        text: 'I need this card, can you help me?',
        cta: 'Send now!',
      },
    },
    card_share_request: {
      'en-card_share_request': {
        text: 'Your friend requested a card',
        cta: 'Give',
      },
    },
    card_share_donate: {
      'en-card_share_donate': {
        text: 'Your friend has given you a card',
        cta: 'Claim',
      },
    },
    card_share_trade: {
      'en-card_share_trade': {
        text: 'Your friend requested to trade this card',
        cta: 'Trade',
      },
    },
    janken_challenge: {
      'en-janken_challenge-1': {
        text: "Bet you can't beat me\nat Janken!",
        cta: 'Accept',
      },
      'en-janken_challenge-2': {
        text: 'Let\u2019s settle this\nwith a Janken match! 👊✋✌️',
        cta: 'Janken',
      },
      'en-janken_challenge-3': {
        text: 'Choose your move!\nI\u2019m waiting for you in Janken.',
        cta: 'Start',
      },
      'en-janken_challenge-4': {
        text: 'Rock, Paper, or Scissors?\nLet\u2019s play Janken!',
        cta: 'Join Match',
      },
    },
  },
  ja: {
    invite: {
      'ja-invite_share': {
        text: 'めっちゃ可愛いゲーム見つけたよ\nぶるぶるどーぶつっていうペット育成ゲームなんだけど、LINEで遊べるから試してみて！',
        cta: '今すぐプレイ！',
      },
    },
    energy_gift: {
      'ja-energy_gift': {
        text: 'エネルギーおくったよ！',
        cta: '今すぐプレイ！',
      },
    },
    gift: {
      'ja-gift': {
        text: 'プレゼント送ったよ！',
        cta: '今すぐプレイ！',
      },
    },
    visited: {
      'ja-visited': {
        text: '置き手紙しておくね',
        cta: '見に行く',
      },
    },
    revived: {
      'ja-revived': {
        text: '置き手紙しておくね',
        cta: '見に行く',
      },
    },
    lastWords: {
      'ja-lastWords': {
        text: '置き手紙しておくね',
        cta: '見に行く',
      },
    },
    card_request: {
      'ja-card_request': {
        text: 'このカードが必要なの！助けてほしいな',
        cta: '今すぐ送る！',
      },
    },
    card_share_request: {
      'ja-card_share_request': {
        text: '友だちがカードをリクエストしています',
        cta: '送る',
      },
    },
    card_share_donate: {
      'ja-card_share_donate': {
        text: '友だちからカードが届いています',
        cta: '受け取る',
      },
    },
    card_share_trade: {
      'ja-card_share_trade': {
        text: '友だちがこのカードのトレードをリクエストしています',
        cta: 'トレード',
      },
    },
    janken_challenge: {
      'ja-janken_challenge-1': {
        text: 'じゃんけんで私に\n勝てるかな？',
        cta: '受ける',
      },
      'ja-janken_challenge-2': {
        text: 'じゃんけんで\n決着つけよう！👊✋✌️',
        cta: 'じゃんけん',
      },
      'ja-janken_challenge-3': {
        text: '手を選んで！\nじゃんけんをしよう！',
        cta: 'スタート',
      },
      'ja-janken_challenge-4': {
        text: 'グー、チョキ、パー？\nじゃんけんしよう！',
        cta: '参加する',
      },
    },
  },
});

export function getCreativeText(
  type: CreativeType,
  substitutions?: { [key: string]: any },
  textId?: string,
  receiverLocale?: Locale,
): CreativeText {
  const locale = receiverLocale ?? StateObserver.getLocale();

  // Fall back to English if we don't have the current locale
  const config = getConfig();
  const messagesObj = config[locale]?.[type] || config.en[type];
  let messageId = '';

  // messages with 'unique' in their key should not be in rotation,
  // they supposed to go together with particular creative
  const messagesArr = Object.keys(messagesObj).filter(
    (key) => key.indexOf('unique') < 0,
  );

  // pick textId if it's passed, otherwise randomly select from existing keys
  messageId = textId || getRandomItemFromArray(messagesArr, Math.random);
  let message = messagesObj[messageId];

  // for unique messages, fallback to English version
  // if message is absent for this locale
  // if something is totally wrong, pick first from existing
  if (!message) {
    messageId = messageId.replace(locale, 'en');
    message =
      config.en[type][messageId] ||
      messagesObj[getRandomItemFromArray(messagesArr, Math.random)];
  }

  // TODO Type safety and all that goodness
  let text = message.text;
  if (substitutions) {
    for (const token in substitutions) {
      text = text.replace('{' + token + '}', substitutions[token]);
    }
  }

  return {
    id: messageId,
    cta: message.cta,
    text: text,
  };
}
